import { NavLink } from 'react-router-dom';
import styled from '@emotion/styled';

import { colors, fontFamily } from '../../../../../styles/globalStyles';

export const StyledDropdownNavLink = styled(NavLink)`
  font-family: ${fontFamily} !important;
  font-size: 16px !important;
  font-weight: 400 !important;
  line-height: 19px !important;
  letter-spacing: -0.32px !important;
  text-decoration: none;
  text-transform: capitalize;
  color: ${colors.darkGrey};

  &:hover {
    background-color: ${colors.aliceBlue} !important;
  }

  &.active {
    color: ${colors.white};
    background-color: ${colors.red};
    &:hover {
      background-color: ${colors.red} !important;
    }
  }
`;
